import React, { memo, useCallback } from "react";
import styled from "styled-components";

const AdminGroupsTabButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-left: 64px;
  padding-top: 30px;
`;

const AdminGroupsTabButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0 15px;
  height: 40px;
  border-radius: 8px;
  background: linear-gradient(180deg, #5172ea -18.38%, #7a5aee 108.82%);
  opacity: ${({ $isActive }) => ($isActive ? "1" : "0.5")};
  cursor: pointer;
  font-size: 16px;
  line-height: 120%;
  color: #fff;
  transition: 0.2s;

  &:hover {
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    ${({ $isActive }) => !$isActive && "opacity: 0.7;"}
  }
`;

const AdminGroupsTabButtons = ({ activeTab, setActiveTab }) => {
  const handleActiveAdminGroupsTab = useCallback((event, tab) => {
    event.stopPropagation();
    setActiveTab(tab);
  }, []);

  return (
    <AdminGroupsTabButtonsContainer>
      <AdminGroupsTabButton
        $isActive={activeTab === "groups"}
        onClick={(e) => handleActiveAdminGroupsTab(e, "groups")}
      >
        Группы
      </AdminGroupsTabButton>
      <AdminGroupsTabButton
        $isActive={activeTab === "votes"}
        onClick={(e) => handleActiveAdminGroupsTab(e, "votes")}
      >
        Голосование
      </AdminGroupsTabButton>
    </AdminGroupsTabButtonsContainer>
  );
};

export default memo(AdminGroupsTabButtons);
